module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"projects":"Projects","project":"Project","desc":"Project Description","emis":"Emissions","cat":"Category","cert":"Certificate","created":"Created on","close_btn":"Close"},"de":{"projects":"Projekte","project":"Projekt","desc":"Projekt Beschreibung","emis":"Emissionen","cat":"Kategorie","cert":"Zertifikat","created":"Erstellt","close_btn":"Schliessen"}}')
  delete Component.options._Ctor
}
